/**
 * @file: useSelectedServiceSubjectsBottomSheetFooterHeight.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

const kHandleHeight = 24;

export const useSelectedServiceSubjectsBottomSheetFooterHeight = () => {
  const insets = useSafeAreaInsets();
  const { rpx } = useResponsiveContext();
  return rpx(54) + Math.max(rpx(10), insets.bottom) + kHandleHeight;
};
